'use client';
import type { PremiseDataDocument } from '@dte/otw-azure-functions/src/common/interfaces/containers/premises/PremiseData';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { ScopeProvider } from 'jotai-scope';
import { AuthenticatedJsonContent } from '../../content/jsonGet/AuthenticatedJsonContent';
import { getPremiseMasterDataURL } from './status/getPremiseMasterDataURL';
import type { PropsWithPremiseId } from './usePremiseId';

export const premiseMasterDataAtom = atom<PremiseDataDocument>();

function PremiseMasterDataContent({ premiseId, children }: PropsWithPremiseId) {
	const url = getPremiseMasterDataURL(premiseId);
	const setMasterDataAtom = useSetAtom(premiseMasterDataAtom);

	return (
		<>
			{children}
			<AuthenticatedJsonContent url={url} setData={setMasterDataAtom} />
		</>
	);
}

export function PremiseMasterDataProvider(props: PropsWithPremiseId) {
	return (
		<ScopeProvider atoms={[premiseMasterDataAtom]}>
			<PremiseMasterDataContent {...props} />
		</ScopeProvider>
	);
}

export function usePremiseMasterData(): PremiseDataDocument {
	return useAtomValue(premiseMasterDataAtom);
}
